import { Add } from 'assets';
import * as setup from 'setup';
import styled from 'styled-components';

export const FunnelGroup = styled.div<FunnelGroupProps>`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: ${({ $collapse }) => $collapse ? '7px' : 'auto'};
    justify-content: ${({ $inverse }) => $inverse ? 'start' : 'end'};
    opacity: ${({ $collapse, $enabled }) => ($collapse || $enabled) ? 1 : 0.3};
    pointer-events: ${({ $enabled }) => $enabled ? 'all' : 'none'};
    position: relative;
    z-index: ${({ $collapse, $index, $inverse }) => $collapse && !$inverse ? (5 - $index) : 10};
`;

export const FunnelAddStepButton = styled(Add)`
    cursor: pointer;
    left: calc(50% - 16px);
    position: absolute;
    top: calc(50% - 16px);
    z-index: 102;
    &:hover > path:first-child {
        fill: ${setup.colors.primary};
    }
`;
